import { render, staticRenderFns } from "./StatsV2.vue?vue&type=template&id=2f9fd398&"
import script from "./StatsV2.vue?vue&type=script&lang=js&"
export * from "./StatsV2.vue?vue&type=script&lang=js&"
import style0 from "./StatsV2.vue?vue&type=style&index=0&id=2f9fd398&prod&lang=scss&"
import style1 from "./StatsV2.vue?vue&type=style&index=1&id=2f9fd398&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports